
import tlMessages from '../locales/tl-TL';

const TlLang = {
    messages: {
        ...tlMessages
    },
    locale: 'tl-TL',
  
};
export default TlLang;